import { useEffect } from "react";

import { useAssessments, useInvitation } from "../../hooks/useFormsLists";
import useToken from "../../hooks/useToken";
import { useSetLocale } from "../../lib/i18n/localeContext";
import { asLocale } from "../../lib/i18n/locales";

export const LocaleResolver: React.FC = () => {
    const setLocale = useSetLocale();
    const { decoded } = useToken();
    const hasAssessmentIds = !!decoded.assessmentIds?.length;
    const isFeedback = !!decoded.receiverEmail;

    const { data: invitation } = useInvitation();
    const { data: assessments } = useAssessments(undefined, hasAssessmentIds);
    const { data: feedbackAssessments } = useAssessments("feedback", isFeedback);

    const targetLanguage = asLocale(
        invitation?.targetLanguage ??
            assessments?.[0]?.targetLanguage ??
            feedbackAssessments?.[0]?.targetLanguage ??
            decoded.targetLanguage
    );

    useEffect(() => {
        if (targetLanguage) {
            setLocale(targetLanguage);
        }
    }, [targetLanguage, setLocale]);

    return null;
};
